
























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

const colors: { [key: string]: string } = {
  '理系数学Ⅱ': 'cyan darken-1',
  '数学Ⅲ': 'blue darken-3',
  '数学': 'blue-grey darken-4',
  '数学Ⅱ': 'light-green darken-1',
  '数学Ｂ': 'lime darken-1',
  '理系数学Ｂ': 'lime darken-1',
}
const comingSoon = "Coming soon"

@Component
export default class Exam extends Vue {
  @Prop({ type: String })
  public examName!: string;
  @Prop({ type: String })
  public subjectName!: string;
  @Prop({ type: String })
  public date!: string;
  @Prop({ type: Boolean, default: false })
  public isOldStyle!: boolean;
  @Prop({ type: String, default: comingSoon })
  public answerDate!: string;
  @Prop({ type: String, default: comingSoon })
  public explanationDate!: string;
  @Prop({ type: String })
  public answerLink!: string
  @Prop({ type: String })
  public explanationLink!: string

  get cardColor() {
    console.log(colors[this.subjectName])
    return colors[this.subjectName]
  }

  get disabledAnswer() {
    return this.answerDate === comingSoon
  }

  get disabledExplanation() {
    return this.explanationDate === comingSoon
  }
}
